import { Link } from '@online-webinar/ui-frontend';
import { Popup } from '../../atoms';

export const WebinarCancelledPopup = () => {
    return (
        <Popup title="This webinar has been cancelled" hasWarning={true} open={true} onClose={() => {}} onConfirm={() => {}} isCloseFunctionality={false}>
            <div>
                <p>
                    We noticed that you want to start your webinar that has been cancelled. Broadcasting is not possible. Please schedule a new event and update
                    your subscribers.
                </p>
                <Link to="/" variant="primary-outline" classNames="mt-4">
                    Go back
                </Link>
            </div>
        </Popup>
    );
};
